import styled from 'styled-components'

export const SurveyItemStyle = styled.div`
  label a {
    color: #3751a2;
    text-decoration: underline;
  }
`
